export type TimestampFormatOptions = {
  dateOnly?: boolean;
  fallback?: string;
};

const DATE_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
  timeZoneName: 'short',
};

const DATE_ONLY_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

export const formatTimestamp = (
  timestamp: string | number | Date | null | undefined,
  options: TimestampFormatOptions = {},
): string => {
  const fallback = options.fallback ?? '—';
  if (timestamp === null || timestamp === undefined || timestamp === '') return fallback;

  const date = timestamp instanceof Date ? timestamp : new Date(timestamp);
  if (Number.isNaN(date.getTime())) return fallback;

  return new Intl.DateTimeFormat(
    undefined,
    options.dateOnly ? DATE_ONLY_OPTIONS : DATE_TIME_OPTIONS,
  ).format(date);
};
